module.exports = __webpack_public_path__ + "static/media/certificate.3147b5d8.jpg";